import FdnNotification from "@fdn/notification";
import FdnNotificationContainer from "@fdn/notification_container";
import PropTypes from "prop-types";

const Mobile = ({ ...props }) => (
	<FdnNotificationContainer
		id="group-notification"
		width="100%"
		top="0"
		right="0"
		left="0"
		padding="16px 16px 0 16px"
	>
		<>
			{props.data.map((notification) => (
				<>
					<FdnNotification
						isMobile
						id={notification.id}
						key={`${notification.id}-mobile`}
						title={notification.title}
						type={notification.type}
						onClose={props.onClose}
						duration={3000}
						closeable
						buttonText={notification.buttonText || ""}
						cta={() => props.handleSeenNotif(notification)}
						body={notification.body || ""}
						width="auto"
					/>
				</>
			))}
		</>
		<style>
			{`
				#notification-container-group-notification.notification__container {
					box-sizing: border-box;
				}
				.notification__learn-more-button {
					border: none !important;
					background: none;
				}
			`}
		</style>
	</FdnNotificationContainer>
);

Mobile.propTypes = {
	data: PropTypes.arrayOf(Object),
	onClose: PropTypes.func.isRequired,
	handleSeenNotif: PropTypes.func.isRequired,
};

Mobile.defaultProps = {
	data: [],
};

export default Mobile;
